import React, { useState, useRef, useEffect } from 'react';
import Distress from '../Image/Distress.jpg';
import Serendipity from '../Image/Serendipity.jpg';
import lis from '../Image/listening.png';
import Atom from '../Music/Distress/Atom.mp3';
import Despair from '../Music/Distress/Despair.mp3';
import harmony from '../Music/Distress/harmony.mp3';
import serfodem from '../Music/Distress/serfodem.mp3';
import opening from '../Music/Serendipity/Serendipity.wav';

import Gokuraku from '../Music/Extra/Gokuraku.wav'
import Siesta from '../Music/Extra/Siesta.wav'
const albums = [
  {
    title: "Distress",
    description: "An electronic and ambient composition featuring layered synthesizers and field recordings.",
    genre: "Electronic, Ambient, Classical",
    year: 2023,
    img: Distress,
    tracks: [
      { title: "Atom", duration: "7:09", file: Atom },
      { title: "Despair", duration: "3:10", file: Despair },
      { title: "Harmony", duration: "1:58", file: harmony },
      { title: "Serfodem", duration: "1:18", file: serfodem },
    ]
  },
  {
    title: "Serendipity",
    description: "An electronic and ambient composition featuring layered synthesizers and field recordings.",
    genre: "Electronic, Ambient, Classical",
    year: 2024,
    img: Serendipity,
    tracks: [
      { title: "Coming soon...", duration: "00:39", file:opening},

    ]
  },
  {
    title: "Extra",
    description: "An electronic track that captures the energy of city life.",
    genre: "Electronic, Ambient, Classical",
    year: 2023,
    img: lis,
    tracks: [
      { title: "Siesta", duration: "00:35", file: Siesta },
      { title: "Gokuraku (極楽)", duration: "2:33", file:Gokuraku },
    
    ]
  }
];

function Music() {
  const [currentPage, setCurrentPage] = useState(1);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [currentAlbum, setCurrentAlbum] = useState(null);
  const AlbumsPerPage = 1;

  const indexOfLastAlbum = currentPage * AlbumsPerPage;
  const indexOfFirstAlbum = indexOfLastAlbum - AlbumsPerPage;
  const currentAlbums = albums.slice(indexOfFirstAlbum, indexOfLastAlbum);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const openModal = (album) => {
    setCurrentAlbum(album);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setCurrentAlbum(null);
  };

  return (
    <section id="music" className="section">
      <h2 className="section-title">Music</h2>
      <p className="section-description" style={{marginBottom:"2%"}}>
        Music is not just a hobby for me; it's a passion that fuels my creativity and complements my technical work. I compose and produce music in various genres, experimenting with different instruments and production techniques. Here are some of my recent albums:
      </p>
      <div className="album-list">
        {currentAlbums.map((album, index) => (
          <div key={index} className="album">
            <div className="album-cover">
              <img src={album.img.toString()} alt={album.title} />
              <button className='listen-btn' onClick={() => openModal(album)}>
                <i className="fas fa-play"></i> Listen
              </button>
            </div>
            <div className="album-info">
              <h3 className="album-title">{album.title}</h3>
              <p className="album-description">{album.description}</p>
              <p className="album-meta"><strong>Genre:</strong> {album.genre}</p>
              <p className="album-meta"><strong>Year:</strong> {album.year}</p>
            </div>
          </div>
        ))}
      </div>
      <Pagination
        AlbumsPerPage={AlbumsPerPage}
        totalAlbums={albums.length}
        paginate={paginate}
        currentPage={currentPage}
      />
      <p className="collaboration-note">
        I'm always open to collaborations and enjoy creating custom music for various projects, including web applications, games, and multimedia presentations. If you're interested in working together on a music project, please don't hesitate to reach out!
      </p>
      {isModalOpen && <Modal album={currentAlbum} closeModal={closeModal} />}
    </section>
  );
}

function Pagination({ AlbumsPerPage, totalAlbums, paginate, currentPage }) {
  const pageNumbers = [];

  for (let i = 1; i <= Math.ceil(totalAlbums / AlbumsPerPage); i++) {
    pageNumbers.push(i);
  }

  return (
    <nav className="pagination">
      {pageNumbers.map(number => (
        <button 
          key={number} 
          onClick={() => paginate(number)} 
          className={`page-btn ${currentPage === number ? 'active' : ''}`}
        >
          {number}
        </button>
      ))}
    </nav>
  );
}

function Modal({ album, closeModal }) {
  const [currentTrack, setCurrentTrack] = useState(album.tracks[0]);
  const [isPlaying, setIsPlaying] = useState(false);
  const [progress, setProgress] = useState(0);
  const audioRef = useRef(new Audio(currentTrack.file));

  useEffect(() => {
    audioRef.current.addEventListener('timeupdate', updateProgress);
    audioRef.current.addEventListener('ended', () => setIsPlaying(false));

    return () => {
      audioRef.current.removeEventListener('timeupdate', updateProgress);
      audioRef.current.removeEventListener('ended', () => setIsPlaying(false));
      audioRef.current.pause();
    };
  }, []);

  useEffect(() => {
    audioRef.current.pause();
    audioRef.current = new Audio(currentTrack.file);
    if (isPlaying) {
      audioRef.current.play();
    }
  }, [currentTrack]);

  const updateProgress = () => {
    const duration = audioRef.current.duration;
    const currentTime = audioRef.current.currentTime;
    const progress = (currentTime / duration) * 100;
    setProgress(progress);
  };

  const togglePlay = () => {
    if (isPlaying) {
      audioRef.current.pause();
    } else {
      audioRef.current.play();
    }
    setIsPlaying(!isPlaying);
  };

  const changeTrack = (track) => {
    setCurrentTrack(track);
    setIsPlaying(true);
  };

  return (
    <div className="modal">
      <div className="modal-content">
        <button className="close-btn" onClick={closeModal}>&times;</button>
        <div className="modal-header">
          <img src={album.img.toString()} alt={album.title} className="album-cover" />
          <div className="album-info">
            <h2 className="album-title">{album.title}</h2>
            <p className="album-description">{album.description}</p>
          </div>
        </div>
        <div className="track-list">
          {album.tracks.map((track, index) => (
            <div 
              key={index} 
              className={`track ${currentTrack === track ? 'active' : ''}`} 
              onClick={() => changeTrack(track)}
            >
              <span className="track-number">{index + 1}</span>
              <span className="track-title">{track.title}</span>
              <span className="track-duration">{track.duration}</span>
              {currentTrack === track && (
                <button className="play-pause-btn" onClick={togglePlay}>
                  <i className={`fas ${isPlaying ? 'fa-pause' : 'fa-play'}`}></i>
                </button>
              )}
            </div>
          ))}
        </div>
        <div className="player">
          <div className="progress-bar">
            <div className="progress" style={{ width: `${progress}%` }}></div>
          </div>
          <div className="player-controls">
            <button className="control-btn" onClick={togglePlay}>
              <i className={`fas ${isPlaying ? 'fa-pause' : 'fa-play'}`}></i>
            </button>
            <div className="track-info">
              <span className="current-track-title">{currentTrack.title}</span>
              <span className="current-track-album">{album.title}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Music;